<template>
  <v-form :ref="formRef"
          class="vorversicherungen">
    <div>
      <v-row no-gutters
             class="align-top-rb-line">
        <v-col cols="12"
               sm="6"
               class="align-top-rb-box">
          <label v-if="formRef === 'vorvervn-form'"
                 class="dmb-form-text">Bestanden/bestehen für den
            <strong>Antragssteller</strong> andere Rechtsschutz-Versicherungen?*
            <site-tooltip v-if="sus && hasvorversicherung =='J'" close-delay="5000">
              <template v-slot:default>
                   Anrechnung der schadenfreien Jahre beim Vorversicherer entweder durch Nachweis (Schadenspiegel und letzter Versicherungsschein) oder 
                   <a :href="nachweisLink()" target="_blank" class="primary--text" style="pointer-events: initial;"><strong>Maklererklärung zum Nachweis der Schadenfreiheit
                   <v-icon size="16px" color="primary">open_in_new</v-icon></strong></a>
                   und Versicherungsumfang ausgefüllt und unterschrieben dem Antrag beifügen.
              </template>
            </site-tooltip>
          </label>
          <label v-else
                 class="dmb-form-text">Bestanden/bestehen für die
            <strong>mitversicherte Person</strong> andere Rechtsschutz-Versicherungen?*
              <site-tooltip v-if="sus && hasvorversicherung =='J'" close-delay="5000">
                <template v-slot:default>
                   Anrechnung der schadenfreien Jahre beim Vorversicherer entweder durch Nachweis (Schadenspiegel und letzter Versicherungsschein) oder 
                   <a :href="nachweisLink()" target="_blank" class="primary--text" style="pointer-events: initial;"><strong>Maklererklärung zum Nachweis der Schadenfreiheit
                   <v-icon size="16px" color="primary">open_in_new</v-icon></strong></a>
                   und Versicherungsumfang ausgefüllt und unterschrieben dem Antrag beifügen.
                </template>
              </site-tooltip>
            </label>
        </v-col>
        <v-col cols="12"
               sm="3">
          <v-radio-group v-model="hasvorversicherung"
                         v-validate="'required'"
                         :error-messages="errors.collect('hasvorversicherung')"
                         data-vv-as="Vorversicherungen"
                         data-vv-name="hasvorversicherung"
                         name="hasvorversicherung"
                         class="align-top-rb ma-0"
                         row>
            <v-radio label="Ja"
                     value="J"
                     color="primary" />
            <v-radio label="Nein"
                     value="N"
                     color="primary" />
          </v-radio-group>
        </v-col>
      </v-row>


      <div v-if="hasvorversicherung==='J'"
           id="vorversicherungenDetails">
        <vor-versicherung v-for="n in anzahlvorversicherungen"
                          :key="n-1"
                          :state-path="statePath + '.vorversicherung.' + (n-1)"
                          :index="n-1"
                          :remove="n === anzahlvorversicherungen && n > 1"
                          class="vorversicherung"
                          @vvdelete="removeVorVers" />


        <v-col v-if="anzahlvorversicherungen < 3"
                cols="12"
                class="pa-0 btn-add-container">
          <div class="btn-add"
               @click="addVorVers">
            <v-icon>add</v-icon>
            <span>Vorversicherung hinzufügen</span>
          </div>
        </v-col>
      </div>

      <v-row no-gutters
             class="align-top-rb-line">
        <v-col cols="12"
               sm="6"
               class="align-top-rb-box">
          <label class="dmb-form-text">Sind gegenwärtig Rechtsstreitigkeiten bekannt?*</label>
        </v-col>
        <v-col cols="12"
               sm="3">
          <v-radio-group v-model="streitAktuell"
                         v-validate="'required'"
                         :error-messages="errors.collect('streitAktuell')"
                         data-vv-as="Aktuelle Rechtsstreitigkeiten"
                         data-vv-name="streitAktuell"
                         class="align-top-rb ma-0"
                         required
                         row>
            <v-radio label="Ja"
                     value="J"
                     color="primary" />
            <v-radio label="Nein"
                     value="N"
                     color="primary" />
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row no-gutters
             class="align-top-rb-line">
        <v-col cols="12"
               sm="6"
               class="align-top-rb-box">
          <label class="dmb-form-text">Ist bereits ein Anwaltsbesuch geplant?*</label>
        </v-col>
        <v-col cols="12"
               sm="3">
          <v-radio-group v-model="anwaltGeplant"
                         v-validate="'required'"
                         :error-messages="errors.collect('anwaltGeplant')"
                         data-vv-as="Geplanter Anwaltsbesuch"
                         data-vv-name="anwaltGeplant"
                         class="align-top-rb ma-0"
                         row>
            <v-radio label="Ja"
                     value="J"
                     color="primary" />
            <v-radio label="Nein"
                     value="N"
                     color="primary" />
          </v-radio-group>
        </v-col>
      </v-row>


      <v-row no-gutters
             class="align-top-rb-line">
        <v-col cols="12"
               sm="6"
               class="align-top-rb-box">
          <label class="dmb-form-text">Rechtsstreitigkeiten in den letzten 5 Jahren*</label>
        </v-col>
        <v-col cols="12"
               sm="3">
          <v-radio-group v-model="hasRechtsstreitigkeiten"
                         v-validate="'required'"
                         :error-messages="errors.collect('hasRechtsstreitigkeiten')"
                         data-vv-as="Rechtsstreitigkeiten"
                         data-vv-name="hasRechtsstreitigkeiten"
                         name="hasRechtsstreitigkeiten"
                         class="align-top-rb ma-0"
                         row>
            <v-radio label="Ja"
                     value="J"
                     color="primary" />
            <v-radio label="Nein"
                     value="N"
                     color="primary" />
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row v-if="hasRechtsstreitigkeiten==='J'"
             no-gutters>
        <v-spacer cols="0"
                  sm="6" />
        <v-col cols="12"
               sm="6">
          <v-text-field v-model="anzahlRechtsstreitigkeiten"
                        v-validate="'required|numeric|min_value:1|max_value:9999'"
                        :error-messages="errors.collect('anzahlRechtsstreitigkeiten')"
                        data-vv-as="Anzahl Rechtsstreitigkeiten"
                        data-vv-name="anzahlRechtsstreitigkeiten"
                        label="Anzahl Rechtsstreitigkeiten"
                        class="required" />
        </v-col>
      </v-row>
      <v-row v-if="hasRechtsstreitigkeiten==='J'"
             no-gutters
             class="pb-3">
        <v-spacer cols="0"
                  sm="6" />
        <v-col cols="12"
               sm="6">
          <v-text-field v-model="leistungshoeheRechtsstreitigkeiten"
                        v-validate="{ required: true, regex: /^[0-9]*(,[0-9]{2})?$/ }"
                        :error-messages="errors.collect('leistungshoeheRechtsstreitigkeiten')"
                        data-vv-as="Leistungshöhe Rechtsstreitigkeiten"
                        suffix="€"
                        class="ma-0 required"
                        name="leistungshoeheRechtsstreitigkeiten"
                        label="Leistungshöhe Rechtsstreitigkeiten" />
        </v-col>
      </v-row>

      <v-row :class="hasAnwaltsbesuche==='J' ? 'align-top-rb-line' : ''"
             no-gutters>
        <v-col cols="12"
               sm="6"
               class="align-top-rb-box">
          <label class="dmb-form-text">Anwaltsbesuche in den letzten 5 Jahren*</label>
        </v-col>
        <v-col cols="12"
               sm="3">
          <v-radio-group v-model="hasAnwaltsbesuche"
                         v-validate="'required'"
                         :error-messages="errors.collect('hasAnwaltsbesuche')"
                         data-vv-as="Anwaltsbesuche"
                         data-vv-name="hasAnwaltsbesuche"
                         name="hasAnwaltsbesuche"
                         class="align-top-rb ma-0"
                         row>
            <v-radio label="Ja"
                     value="J"
                     color="primary" />
            <v-radio label="Nein"
                     value="N"
                     color="primary" />
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row v-if="hasAnwaltsbesuche==='J'"
             no-gutters>
        <v-spacer cols="0"
                  sm="6" />
        <v-col cols="12"
               sm="6">
          <v-text-field v-model="anzahlAnwaltsbesuche"
                        v-validate="'required|numeric|min_value:1|max_value:9999'"
                        :error-messages="errors.collect('anzahlAnwaltsbesuche')"
                        data-vv-as="Anzahl Anwaltsbesuche"
                        data-vv-name="anzahlAnwaltsbesuche"
                        label="Anzahl Anwaltsbesuche"
                        class="required" />
        </v-col>
      </v-row>

      <v-row v-if="hasAnwaltsbesuche==='J'"
             no-gutters>
        <v-spacer cols="0"
                  sm="6" />
        <v-col cols="12"
               sm="6">
          <v-text-field v-model="leistungshoeheAnwaltsbesuche"
                        v-validate="{ required: true, regex: /^[0-9]*(,[0-9]{2})?$/ }"
                        :error-messages="errors.collect('leistungshoeheAnwaltsbesuche')"
                        data-vv-as="Leistungshöhe Anwaltsbesuche"
                        suffix="€"
                        class="ma-0 required"
                        name="leistungshoeheAnwaltsbesuche"
                        label="Leistungshöhe Anwaltsbesuche" />
        </v-col>
      </v-row>

    </div>
  </v-form>
</template>

<script>
import VorVersicherung from "@/components/privatkundenrechner/VorVersicherung.vue";
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";

export default {
  components: { VorVersicherung },
  mixins: [ValidationMixin, twowayBinding, contentLoadingMixin(["nachweis_vorversicherer"])],
  props: {
    formRef: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapTwoWay([
      "hasvorversicherung",
      "anzahlvorversicherungen",
      "hasRechtsstreitigkeiten",
      "anzahlRechtsstreitigkeiten",
      "leistungshoeheRechtsstreitigkeiten",
      "hasAnwaltsbesuche",
      "anzahlAnwaltsbesuche",
      "leistungshoeheAnwaltsbesuche",
      "anwaltGeplant",
      "streitAktuell"
    ]),
   ...mapTwoWay(["sus"], {}, "b") // this.statePath.split(".")[0]
  },
  methods: {
    removeVorVers() {
      this.$store.commit('removeVorversicherung', {rootState: this.$store.state, statePath: this.statePath});
    },
    addVorVers() {
      this.$store.commit('addVorversicherung', { rootState: this.$store.state, statePath: this.statePath});
    },
    nachweisLink() {
      return this.nachweis_vorversicherer ? this.nachweis_vorversicherer.items[0].link : null;
    }
  }
};
</script>

<style>
.vorversicherungen {
  width: 100%;
}

.vorversicherungen .v-icon {
  cursor: pointer;
}

.vorversicherungen .v-input.v-input--selection-controls.vtfy-lined-input {
  /*make checkboxes align with text-inputs  */
  padding-top: 18px;
}

.vorversicherungen .btn-add-container {
  display: flex;
  justify-content: center;
  margin: 0 0 24px 0;
}

.vorversicherungen .btn-add {
  border: none !important;
  margin: 16px 0 0 0 !important;
  font-size: 16px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
}

.vorversicherungen .btn-add .v-icon, .vorversicherungen .btn-add span {
  color: rgba(0, 0, 0, .87);
  cursor: pointer;
}

.vorversicherungen .btn-add:hover .v-icon, .vorversicherungen .btn-add:hover span {
  color: #0085CF !important;
}

.vorversicherungen .vorversicherung + .vorversicherung {
  margin-top: 16px;
}

.vorversicherungen #vorversicherungenDetails {
  margin-bottom: 32px;
}

.vorversicherungen .v-messages {
  overflow: visible;
  white-space: nowrap;
}

.vorversicherungen .v-input--radio-group__input .v-radio:not(:last-child) {
  margin-right: 48px!important;
}

</style>

